import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import CartIcon from "@/assets/icons/shopping-bag.svg?react";
import { renderRow, compareRows } from "./renderRow";
import { togglePopUp } from "@/redux-store/cartPopUp/cartPopUpSlice";
import {useAppDispatch, useAppSelector} from "@/redux-store/hooks";
import {useAddEditCartMutation} from "@/redux-store/api/marketingApi.ts";
import {addProductToCart} from "@/redux-store/cart/cartSlice.ts";

interface IProps {
  compareProducts: ISimilarProduct[];
}

const ComparisonTable: React.FC<IProps> = ({ compareProducts }) => {
  const dispatch = useAppDispatch();
  const [addEditCartMutation] = useAddEditCartMutation();
  const sessionId = useAppSelector((state) => state.cart.sessionId);
  // Add product to the cart
  const addToCart = async (product: any) => {
    // Find if product is already in a Cart
    const productData = {
      IdShoppingCart: null,
      IdProduct: product.id,
      Quantity: 1,
      Price: product.price,
      SessionId: sessionId,
    };

    try {
      await addEditCartMutation(productData).unwrap();
      dispatch(addProductToCart({
        idProduct: product.id,
        quantity: 1,
        price: product.price
      } as ICartProduct));
      dispatch(togglePopUp());
    } catch (error) {
      console.error("Error add", error);
    }
  };
  return (
    <TableContainer
      sx={{
        width: "100%",
        overflowX: "auto",
      }}
    >
      <Table sx={{ "& .MuiTableCell-root": { borderBottom: "none" } }}>
        <TableBody>
          {compareRows.map((row) => (
            <TableRow key={row}>{renderRow(row, compareProducts)}</TableRow>
          ))}

          <TableRow>
            {compareProducts.map((product) => (
              <TableCell
                key={product.id}
                sx={{ pt: 0, pb: 2, px: { xs: 1.5, md: 2, lg: 3, xl: 7 } }}
              >
                <Button
                  variant="contained"
                  sx={{ "& svg": { stroke: "white" } }}
                  endIcon={<CartIcon />}
                  fullWidth
                  onClick={() => addToCart(product)}
                  disabled={(product?.availableQuantity || 0) <= 0}
                >
                  {(product?.availableQuantity || 0) > 0 ? "Add to Cart" : "Out of Stock"}
                </Button>
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ComparisonTable;
